import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  earnedPointsData: [],
  redeemedPointsData: [],
  expiredPointsData: [],
  expiringPointsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchEarnedPoints = createAsyncThunk(
  "points/fetchEarnedPoints",
  async () => {
    try {
      const result = await axios.get(
        "https://apac.api.capillarytech.com/mobile/v2/api/points/history"
      );
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const earnedPointsSlice = createSlice({
  name: "earned-points",
  initialState,
  reducers: {
    resetEarnedAndRedeemedPoints: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.earnedPointsData = [];
      state.redeemedPointsData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEarnedPoints.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEarnedPoints.fulfilled, (state, action) => {
   
      state.loading = false;
      state.earnedPointsData =
        action.payload?.customer?.transactions?.transaction;
      state.redeemedPointsData =
        action.payload?.customerburn?.redemptions?.points?.point;
        state.expiredPointsData = action.payload?.expired_points?.[0]?.item;
        state.expiringPointsData = action.payload?.
        expiry_schedule?.[0]?.schedule;
      state.success =
        action.payload?.status?.success === ("true" || true) ? true : false;
      state.error = "";
    });
    builder.addCase(fetchEarnedPoints.rejected, (state, action) => {
      state.loading = false;
      state.earnedPointsData = [];
      state.redeemedPointsData = [];
      state.expiredPointsData = [];
      state.expiringPointsData = [];
      state.error = action.error.message;
    });
  },
});

export default earnedPointsSlice.reducer;
export const { resetEarnedAndRedeemedPoints } = earnedPointsSlice.actions;
export { fetchEarnedPoints };
